import React, { useEffect, useState } from 'react';
import { AiOutlineLeft } from 'react-icons/ai';
import moment from 'moment';
import { useHistory, useParams } from 'react-router-dom';
import { GetAInfluencer } from '../../apis/Brand/Discovery/GetAInfluencer';
import { getInfluencerFollowersGenderAge } from '../../apis/Brand/Discovery/GetInfluencerAge';
import { getInfluencerFollowersChange } from '../../apis/Brand/Discovery/GetInfluencerFollowerchange';
import { getInfluencerFollowersCity } from '../../apis/Brand/Discovery/GetInfluencerFollowersCity';
import { getInfluencerFollowersCountry } from '../../apis/Brand/Discovery/GetInfluencerFollowersCountry';
import { getInfluencerPosts } from '../../apis/Brand/Discovery/GetInfluencerPosts';
import { getInfluencerReach } from '../../apis/Brand/Discovery/GetInfluencerReach';
import BrandTopSubHeaderComponent from '../../components/Brand/Common/BrandTopSubHeaderComponent';
import ProfileAboutComponent from '../../components/Brand/Discovery/ProfileAboutComponent';
import ProfileBasicComponent from '../../components/Brand/Discovery/ProfileBasicComponent';
import ProfileEarnStatsComponent from '../../components/Brand/Discovery/ProfileEarnStatsComponent';
import BrandBaseLayoutComponent from '../../components/Layout/Brand/BrandBaseLayoutComponent';
import { useGlobalState } from '../../store/state';
export const BrandInfluencerProfilePage = () => {
  const history = useHistory();
  const params = useParams();
  const [user] = useGlobalState('user');
  const [influData, setInfluData] = useState({});

  const [post, setPost] = useState([]);
  const [followersChnage, setFollowersChnage] = useState([]);
  const [reachStats, setReachStats] = useState([]);
  const [impressionsStats, setImpressionsStats] = useState([]);
  const [genderStats, setGenderStats] = useState([]);
  const [ageStats, setAgeStats] = useState([]);
  const [cityStats, setCityStats] = useState([]);
  const [countryStats, setCountryStats] = useState([]);

  const fetchInfluencerPosts = (limit, page) => {
    getInfluencerPosts({ limit, page, token: user.accessToken, influencerId: params.influencerId }).then(( res )=>{
      if (res.status === 200) {
        setPost({
          ...res,
        });
      } else {
        console.log('Failed to fetch dicovery data', res);
      }
    });
  };

  const fetchInfluencerFollowersChange = () =>{
    getInfluencerFollowersChange({ token: user.accessToken, influencerId: params.influencerId }).then((res)=>{
      if (res.status === 200) {
        let data = res.response.data;
        data = data.map((item) => {
          item.date = moment(item.end_time).format('MMM DD, YYYY');
          return item;
        });
        setFollowersChnage(data);
      }
    });
  };

  const fetchInfluencerReachImpressionsStats = () =>{
    getInfluencerReach({ token: user.accessToken, influencerId: params.influencerId }).then((res)=>{
      if (res.status === 200) {
        const data = res.response.data;
        let reach = data.reach;
        console.log({ reach });
        let impressions = data.impressions;
        reach = reach.map((item) => {
          item.date = moment(item.end_time).format('MMM DD, YYYY');
          return item;
        });
        impressions = impressions.map((item) => {
          item.date = moment(item.end_time).format('MMM DD, YYYY');
          return item;
        });
        setImpressionsStats(impressions);
        setReachStats(reach);
      }
    });
  };

  const fetchInfluencerFollowersGenderAgeStats = () =>{
    getInfluencerFollowersGenderAge({ token: user.accessToken, influencerId: params.influencerId }).then(( res )=>{
      console.log('Fetched influencer followers', res);
      if (res.status === 200) {
        const data = res.response.data[0].value;
        const genderStat = Object.keys(data).reduce((acc, key) => {
          if (key[0] === 'F') {
            return { ...acc, female: acc.female + data[key] };
          } else if (key[0] === 'M') {
            return { ...acc, male: acc.male + data[key] };
          } else {
            return { ...acc, unknown: acc.unknown + data[key] };
          }
        }, {
          'male': 0,
          'female': 0,
          'unknown': 0,
        });
        setGenderStats([
          {
            type: 'Male',
            value: genderStat.male || 0,
          },
          {
            type: 'Female',
            value: genderStat.female || 0,
          },
          {
            type: 'Unknown',
            value: genderStat.unknown || 0,
          },
        ]);

        // Get Age Group

        // {
        //   'name': 'Female',
        //   'ageGroup': '55-64',
        //   'value': 35.5,
        // },
        const ageGroup = Object.keys(data).map((key) => {
          if (key[0] === 'F') {
            return {
              name: 'Female',
              ageGroup: key.slice(2),
              value: data[key],
            };
          } else if (key[0] === 'M') {
            return {
              name: 'Male',
              ageGroup: key.slice(2),
              value: data[key],
            };
          } else {
            return {
              name: 'Unkown',
              ageGroup: key.slice(2),
              value: data[key],
            };
          }
        });
        setAgeStats(ageGroup);
      }
    });
  };

  const fetchInfluencerFollowersCityStats = () =>{
    getInfluencerFollowersCity({ token: user.accessToken, influencerId: params.influencerId }).then(( res )=>{
      if (res.status === 200) {
        const data = res.response.data[0].value;
        const cityStats = Object.keys(data).map((key) => {
          return {
            name: key,
            value: data[key],
          };
        });
        setCityStats(cityStats.sort((a, b) => b.value - a.value));
      }
    });
  };

  const fetchInfluencerFollowersCountryStats = () =>{
    getInfluencerFollowersCountry({ token: user.accessToken, influencerId: params.influencerId }).then(( res )=>{
      if (res.status === 200) {
        const data = res.response.data[0].value;
        const countryStats = Object.keys(data).map((key) => {
          return {
            name: key,
            value: data[key],
          };
        });
        setCountryStats(countryStats.sort((a, b) => b.value - a.value));
      }
    });
  };

  useEffect(() => {
    GetAInfluencer(user.accessToken, params.influencerId).then(({ status, response })=>{
      console.log('response', response);
      if (status === 200) {
        setInfluData({
          ...response,
        });
      }
    });
    fetchInfluencerFollowersCountryStats();
    fetchInfluencerFollowersCityStats();
    fetchInfluencerFollowersGenderAgeStats();
    fetchInfluencerReachImpressionsStats();
    fetchInfluencerFollowersChange();
    fetchInfluencerPosts(10, 1);
  }, []);


  return (
    <BrandBaseLayoutComponent>
      <BrandTopSubHeaderComponent className="px-3 py-1 sticky">
        <p className="m-0">
          <a style={{ cursor: 'pointer' }}
            className="stat_over_header_title--back"
            onClick={history.goBack}>
            <AiOutlineLeft/>
          </a>
          <span className="pl-2"><strong>Influencer Profile</strong></span>
        </p>
      </BrandTopSubHeaderComponent>
      <div className="d-flex flex-wrap px-2">
        <ProfileBasicComponent
          picture={influData.picture}
          firstname={influData.firstname}
          lastname={influData.lastname}
          gender={influData.gender}
          city_living={influData.city_living}
          id={influData.id}
          interests={influData.interests}
          youtube_account={influData.youtube_account}
          twitter_account={influData.twitter_account}
          instagram_account={influData.instagram_account}

        />
        {/* TODO:// Make platform independent */}
        <ProfileEarnStatsComponent followers={influData?.instagram_account?.influencersocialid?.followingSubscribers}/>
        <ProfileAboutComponent about={influData.shortinfo}
          location={influData.location}
          age={influData.age}
          languages={influData.languages}
          address={influData.address}
          interests={influData.interests}
          flyntVerified={influData.verified}
          post={post}
          followersChnage={followersChnage}
          cityStats={cityStats}
          countryStats={countryStats}
          reachStats={reachStats}
          impressionsStats={impressionsStats}
          genderStats={genderStats}
          ageStats={ageStats}
          gender={influData.gender}
        />
      </div>
    </BrandBaseLayoutComponent>
  );
};
